import { cx } from '../../utils/cx';

export type PriceProps = {
  cents: number | null | undefined;
  /** ISO currency (the family's). */
  currency?: string;
  /** Prefix "about " for estimates/totals. */
  approximate?: boolean;
  className?: string;
};

/** "$49.99", or "$18" for whole amounts. Renders nothing for unknown prices. */
export function formatPrice(cents: number, currency = 'USD', locale?: string): string {
  const whole = cents % 100 === 0;
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: whole ? 0 : 2,
    maximumFractionDigits: whole ? 0 : 2,
  }).format(cents / 100);
}

export function Price({ cents, currency = 'USD', approximate, className }: PriceProps) {
  if (cents === null || cents === undefined) return null;
  return (
    <span className={cx(className)} style={{ fontVariantNumeric: 'tabular-nums' }}>
      {approximate ? 'about ' : ''}
      {formatPrice(cents, currency)}
    </span>
  );
}
